/**
 * contentApi — minimal web port of `apps/WunderGuide/api/contentApi.ts`.
 *
 * Currently only exposes `fetchSuggestedPrompts` since that is what the
 * Dashboard needs. Endpoint and parameter shape match RN exactly so a
 * shared `@wg/api` wrapper can replace this later without touching callers.
 */
import { httpClient } from '../http';

export interface SuggestedPrompt {
  promptId?: string;
  text: string;
  contextMatch?: boolean;
  direction?: 'ltr' | 'rtl' | 'auto';
  displayConfig?: {
    style?: Record<string, unknown>;
  };
}

export interface SuggestedPromptsContent {
  prompts: SuggestedPrompt[];
  ui?: { header?: string };
  globalConfig?: {
    direction?: 'ltr' | 'rtl' | 'auto';
    timing?: {
      defaultAutoPlayInterval?: number;
      defaultTransitionDuration?: number;
      enableLoop?: boolean;
    };
  } | null;
}

export async function fetchSuggestedPrompts(
  sessionId: string,
  options: {
    language?: string;
    destination?: string;
    limit?: number;
    timeOfDay?: 'morning' | 'afternoon' | 'evening' | 'night';
    latitude?: number;
    longitude?: number;
  } = {},
): Promise<SuggestedPromptsContent> {
  const params: Record<string, string> = {
    language: options.language || 'en-US',
    destination: options.destination || 'hawaii',
    limit: String(options.limit ?? 5),
  };
  if (options.timeOfDay) params.time_of_day = options.timeOfDay;
  if (options.latitude !== undefined)
    params.latitude = String(options.latitude);
  if (options.longitude !== undefined)
    params.longitude = String(options.longitude);

  const url = `/functions/v1/content/sessions/${sessionId}/suggested-prompts`;
  const { data } = await httpClient.get<SuggestedPromptsContent>(url, {
    params,
  });
  return data;
}
